import { processApiFieldErrors } from '../../../../utils/processApiFieldErrors'
// getErrorMessage lives in utils.js; TS imports it fine (allowJs: true).
import { getErrorMessage } from '../../../../utils/utils'
import { collapseIndexedFieldErrors } from './collapseIndexedFieldErrors'

export interface ApplyApiAccessErrorDeps {
  fieldMap: Record<string, string>
  titleMap: Record<string, string>
  /** Formik `setErrors`. */
  setErrors: (errors: Record<string, string>) => void
  /** Formik `setTouched`; the web inputs only show an error once touched. */
  setTouched: (touched: Record<string, boolean>) => void
  /** Toast for errors that belong to no field. */
  notifyError: (message: string) => void
}

/**
 * A failed plugin key / API token save → inline Formik errors, or a toast when
 * nothing maps to a field. Same policy as the Edit Player and SportsPay forms.
 */
export const applyApiAccessError = (
  err: unknown,
  {
    fieldMap,
    titleMap,
    setErrors,
    setTouched,
    notifyError,
  }: ApplyApiAccessErrorDeps
): void => {
  const e = err as {
    invalid_fields?: Record<string, string | string[]>
    message?: string
  }
  const { formErrors } = processApiFieldErrors(
    collapseIndexedFieldErrors(e.invalid_fields),
    { fieldMap, titleMap }
  )

  const fields = Object.keys(formErrors)
  if (fields.length === 0) {
    notifyError(e.message ?? getErrorMessage(err))
    return
  }

  setErrors(formErrors)
  setTouched(
    fields.reduce<Record<string, boolean>>((touched, field) => {
      touched[field] = true
      return touched
    }, {})
  )
}
